import React from "react";
import { Box } from "@mui/material";
export const MobileCard = ({ onClick, children, sx, }) => {
    return (React.createElement(Box, { onClick: onClick, sx: Object.assign({ p: 2, backgroundColor: "background.default", borderRadius: 4, border: "1px solid", borderColor: "action.focus", cursor: onClick ? "pointer" : "default", display: "flex", flexDirection: "column", gap: 1.5, height: "100%", "&:hover": onClick
                ? { backgroundColor: "action.hover" }
                : undefined }, sx) }, children));
};
